import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-bar-date',
    templateUrl: './bar-date.component.html',
    styleUrls: ['./bar-date.component.css'],
    standalone: true,
    imports: [DatePipe]
})
export class BarDateComponent {
  
  @Input() infoDia = '';
  @Input() data = Date.now();

}
